import Vue from 'vue';
let bus = new Vue({
    data: {
        regs: {
            loginPWD: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,32}$/,
            transPWD: /.{6,32}/
        }
    }
});
export default bus;